/**
 * Label — atom for FormField. ADR-0007.
 * htmlFor required for a11y.
 */
import type { LabelHTMLAttributes } from 'react'

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  htmlFor: string
  required?: boolean
}

export function Label({ htmlFor, required, children, className = '', ...rest }: LabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      className={`block text-sm font-semibold text-text-primary mb-1.5 ${className}`}
      {...rest}
    >
      {children}
      {required && <span aria-hidden="true" className="text-text-danger ml-0.5">*</span>}
    </label>
  )
}
